export default __webpack_public_path__ + "static/Standing_Torch-92f80dd5f79b757bcf8c1948a1979ef2.png";